import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useBasePath } from '../../../../../../global/hooks/useBasePath';
import { useQuery } from '../../../../../../global/hooks/useQuery';
import { TcsmEpiApiState, TcsmStates } from '../../../../../../root/tcsm-model';
import { ArcRoutes } from '../../../../constants/routes';
import { usePlanSummary } from '../../plan-summary/usePlanSummary';
import { GetPlanAdoptionWizard } from '../factory/plan-adoption-wizard-factory';
import { PlanAdoptionFormTypes } from '../models/plan-adoption-form-models';
import { LayDbPlanAdoptionWizard } from '../wizards/lay-db-plan-adoption-wizard';
import DbPlanAdoptionForm from './db-plan-adoption-form';


function DbPlanAdoption() {
	const formType = useQuery().get('formType') as unknown;
	const dispatch = useDispatch();
	const history = useHistory();
	const epiContent = useSelector<TcsmStates, TcsmEpiApiState>(state => state?.epiProps);
	const onSuccessUrl = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.PlanSummary}`);
	const wizard = GetPlanAdoptionWizard({ formType: formType as PlanAdoptionFormTypes, dispatch, history, epiContent, onSuccessUrl });
	const instiutionId = useSelector<TcsmStates, string>(state => state?.institutionState?.currentInstitution?.org_client_nbr);
	const planSummaryLoaded = usePlanSummary(instiutionId);
	if (!wizard || !planSummaryLoaded) {
		return null;
	}

	return <DbPlanAdoptionForm wizard={wizard as LayDbPlanAdoptionWizard} />;

}

export default DbPlanAdoption;